import { render, staticRenderFns } from "./SiteName.vue?vue&type=template&id=686bc3f7&"
import script from "./SiteName.vue?vue&type=script&lang=js&"
export * from "./SiteName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports